var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './SonarModal.scss';
import classNames from 'classnames';
import React from 'react';
import { Modal } from 'antd';
export const SonarModal = (_a) => {
    var { afterClose, children, className, fixedWidth, open } = _a, rest = __rest(_a, ["afterClose", "children", "className", "fixedWidth", "open"]);
    const handleAfterClose = () => {
        if (afterClose) {
            afterClose();
        }
    };
    return (React.createElement(Modal, Object.assign({ afterClose: handleAfterClose, className: classNames('sonar-modal', className), open: open, width: fixedWidth ? undefined : 'fit-content' }, rest), children));
};
